import * as React from "react";
import { formatDateTime } from "../../CommonFunctions";
import {WarningBanner} from "@ferry/portal-core";

interface IProps {
    product: string;
    productWording: React.ReactNode;
    endDate: string;
}

export class RenewalDeclinedBanner extends React.Component<IProps> {
    constructor(props: any) {
        super(props);
    }

    public render() {
        return (
            <WarningBanner wording={
                <>
                    Heads up - your {this.props.product} policy for {this.props.productWording} <strong>ends on {formatDateTime(this.props.endDate)}.</strong>{' '}
                    Until then you are still covered.
                    <span className="font-weight-bold">Make sure you arrange alternative cover for your {this.props.product}.</span>
                </>
            }/>
        );
    }
}
